export default __webpack_public_path__ + "static/media/Roboto-Medium.ef677e21.ttf";